import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const VisitorTracker = () => {
  const { pathname, search } = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = `${pathname}${search}`;

    if (lastPath.current === path) {
      return;
    }

    lastPath.current = path;

    axios.post('/visitor', { path }).catch(() => undefined);
  }, [pathname, search]);

  return null;
};

export default VisitorTracker;
